module.exports = __webpack_public_path__ + "static/media/sign-out-option.5256142a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sign-out-option.svg
// module id = 2346
// module chunks = 0